import { render, staticRenderFns } from "./ReceitaNetCopyRight.vue?vue&type=template&id=ef756f80&"
import script from "./ReceitaNetCopyRight.vue?vue&type=script&lang=js&"
export * from "./ReceitaNetCopyRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports